angular.module 'zc.commonApi'
.service 'campaignGraphOptions', ($filter) ->
  return [
    {
      name: 'delivery_count',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.deliveryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.visit'),
      decimal: 0,
    },
    {
      name: 'conversion_count',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion'),
      decimal: 0,
      },
    {
      name: 'conversion_rate',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion_rate'),
      unit: ' %',
      decimal: 1,
    },
    {
      name: 'cvr_increase_rate',
      isMasterOnly: true
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cvrIncreaseRate'),
      unit: ' %',
      decimal: 1,
    },
    {
      name: 'cart_button_click_rate',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartButtonClickRate'),
      unit: ' %',
      decimal: 1,
    },
    {
      name: 'cart_through_rate',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartThroughRate'),
      unit: ' %',
      decimal: 2,
    },
    {
      name: 'average_history_count',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageHistoryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.pageView'),
      decimal: 1,
    },
    {
      name: 'average_dwell',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageDwell'),
      unit: $filter('translate')('sharedModules.dateTimeFormats.minute'),
      decimal: 1,
    },
    {
      name: 'average_conversion_price',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageConversionPrice'),
      unit: '',
      decimal: 0,
    },
    {
      name: 'conversion_price',
      isMasterOnly: false
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionPrice'),
      unit: '',
      decimal: 0,
    },
  ]



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/misc/campaign_graph_options.coffee